export const PII_MASK_CSS_CLASS = 'ph-no-capture';
